import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { orderErrorMessage, useReopenOrder } from '../../../entities/order';
import { Button } from '../../../shared/ui/button';
import { ConfirmDialog } from '../../../shared/ui/confirm-dialog';
import { toast } from '../../../shared/ui/sonner';

/**
 * **Edit order** while it is unpaid: behind a confirmation, the order returns to draft, so its details and options
 * can be changed and the price is worked out again at the next submit. Shown to someone with `orders.create`; the
 * worker asks the database before it does anything.
 */
export function ReopenOrderButton({ orderId }: { orderId: string }) {
  const { t } = useTranslation('order');
  const reopen = useReopenOrder();
  const [confirming, setConfirming] = useState(false);
  return (
    <>
      <Button variant="secondary" onClick={() => setConfirming(true)}>
        {t('reopen.action')}
      </Button>
      <ConfirmDialog
        open={confirming}
        onOpenChange={setConfirming}
        variant="primary"
        title={t('reopen.title')}
        description={t('reopen.body')}
        confirmLabel={t('reopen.yes')}
        cancelLabel={t('reopen.no')}
        errorMessage={orderErrorMessage}
        onConfirm={async () => {
          await reopen.mutateAsync(orderId);
          toast.success(t('reopen.done'));
        }}
      />
    </>
  );
}
